import { render, staticRenderFns } from "./QuoteSignMLA.vue?vue&type=template&id=a22734be&"
import script from "./QuoteSignMLA.vue?vue&type=script&lang=js&"
export * from "./QuoteSignMLA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports